<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>消息通知</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="conentBox">
        <div class="btns">
            <div @click="btnsTz">
              <img src="@/assets/adds.png" alt="">
              发布通知</div>
            </div>
        <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
      >
        <el-table-column type="index" :index="hIndex" label="序号" width="70">
        </el-table-column>
        <el-table-column prop="sendtime" label="发布时间" width="200"></el-table-column>
        <el-table-column prop="title" label="消息名称"></el-table-column>
        <el-table-column prop="scenicname" label="发布至..."></el-table-column>
        <el-table-column prop="AgentPrice" label="发布状态">
          <template slot-scope="scope">
            {{scope.row.state=='1'?'已发布':'定时发布'}}
          </template>
        </el-table-column>
        <el-table-column prop="adminuser" label="发布者">
        </el-table-column>
        <el-table-column prop="address" label="操作" width="200">
            <template slot-scope="scope">
              <div  style="display:flex;justify-content: center;">
                <div class="detele" @click="deteleClik(scope.row)">删除</div>
                <div class="tow_btns" @click="modify(scope.row)">修改</div>
              </div>
            </template>
        </el-table-column>
      </el-table>
      <!-- 分页开始 -->
      <div class="pagination">
        <span class="demonstration">共{{total}}条记录，</span>
        <span class="demonstration">当前显示第{{data.page}}页</span>
        <el-pagination background layout="prev, pager, next" :page-size="data.page_size" :total="total" :current-page="data.page"  @current-change="pagination" ></el-pagination>
      </div>
    </el-card>
    <el-dialog :close-on-click-modal="false"
      title="发布通知"
      :visible.sync="flow"
      :before-close="Close"
      width="36%"
      center
    >
      <el-divider></el-divider>
      <div class="form_tz">
        <el-form :model="ruleForm"  ref="ruleForm" label-width="80px" class="demo-ruleForm">
            <el-form-item label="主题：" prop="title">
              <el-input v-model="ruleForm.title"></el-input>
            </el-form-item>
            <el-form-item label="内容：" prop="title">
              <el-input type="textarea" :autosize="{ minRows: 8, maxRows: 8}" v-model="ruleForm.content"></el-input>
            </el-form-item>
            <el-form-item label="发布至：" prop="title">
              <div class="fabu" @click="openscenic">
                <span>选择景区</span>
                <img src="@/assets/spin.png" alt="">
              </div>
            </el-form-item>
            <div class="scenic">
              <div v-for="(item,index) in option" :key="index">
                {{item.Name}}
                <img src="@/assets/closeP.png" alt="" @click="detele(index)">
              </div>
            </div>
            <el-form-item label="发布至：" prop="title">
              <el-radio v-model="ruleForm.state" label="1">及时发布</el-radio>
              <el-radio v-model="ruleForm.state" label="2">定时发布</el-radio>
            </el-form-item>
            <div class="el_times" v-if="ruleForm.state==2">
              <el-date-picker
                v-model="ruleForm.sendtime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
              </el-date-picker>
            </div>
        </el-form>
        <div class="form_btn">
          <div @click="Close">取消</div>
          <div @click="addNews">完成</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false"
      title="选择景区"
      :visible.sync="scenicflow"
      :before-close="scenicClose"
      width="36%"
      center
    >
      <el-divider></el-divider>
      <div class="scenic_box">
          <div class="top">
            <el-select v-model="data1.proid" clearable  placeholder="请选择省份">
              <el-option
                v-for="item in cityProvince"
                :key="item.provinceCode"
                :label="item.provinceName"
                :value="item.provinceCode"
              ></el-option>
            </el-select>
            <el-input v-model="data1.scenic_name"></el-input>
            <div class="btns_top" @click="shai">筛选</div>
          </div> 
          <div class="bottom">
            <div v-for="(item,index) in arr" :key="index">
              <el-checkbox v-model="item.checked" @change="checkedChange(item,$event)">{{item.Name}}</el-checkbox>
            </div>
          </div>
          <div class="form_btn">
            <div @click="scenicClose">取消</div>
            <div @click="formBtns">完成</div>
          </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getNoticeList , sendAdminNotice , deleteNotice } from "@/request/set.js";
import { scenicPost } from "@/request/scenics.js";
import cityOptions from "@/assets/city.json";
import { MessageBox,Message} from 'element-ui'
export default {
  data(){
    return{
      value:'',
      scenicflow:false,
      ruleForm:{
        token:window.sessionStorage.getItem("Token"),
        title:'',
        content:'',
        notice_sceincid:'',
        state:'1',
        sendtime:'',
        id:''
      },
      tableData:[],
      total:0,
      data:{
        token:window.sessionStorage.getItem("Token"),
        page:1,
        page_size:10,
        pageIndexCopy:1
      },
      flow:false,
      option:[],
      arr:[],
      data1:{
        token:window.sessionStorage.getItem("Token"),
        page:1,
        page_size:999,
        scenic_name:'',
        proid:''
      },
      cityProvince:''
    }
  },
  created(){
    this.cityProvince = cityOptions;
    this.getList()
  },
  methods:{
    hIndex(index){
      return (this.data.pageIndexCopy- 1) * this.data.page_size + index + 1
    },
    pagination(e){
      this.data.page = e
      this.data.pageIndexCopy = e
      this.getList()
    },
    deteleClik(row){
      MessageBox('此操作将删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data = {
            token:window.sessionStorage.getItem("Token"),
            id:row.id,
            state:3
          }
          deleteNotice(data).then(res=>{
            if(res.data.rcode==200){
              this.data.page = 1
              this.getList()
              Message.success('删除成功')
            }
          })
        }).catch(() => {
                 
       });
    },
    detele(index){
      this.option.splice(index, 1);
    },
    modify(row){
      this.ruleForm = {
        token:window.sessionStorage.getItem("Token"),
        title:row.title,
        content:row.content,
        notice_sceincid:row.notice_sceincid,
        state:row.state +'',
        sendtime:row.sendtime,
        id:row.id
      }
      this.secenL(row.notice_sceincid)
      this.flow = true
    },
    addNews(){
      if(this.ruleForm.title==''){
        Message.error('请输入主题')
        return false
      }
      if(this.ruleForm.content==''){
        Message.error('请输入内容')
        return false
      }
      var scenic = ''
      if(this.option.length==0){
        this.ruleForm.notice_sceincid=0
      }else{
        this.option.map(item=>{
          scenic += item.ScenicID + ','
        })
        this.ruleForm.notice_sceincid = scenic.slice(0,-1)
      }
      sendAdminNotice(this.ruleForm).then(res=>{
        if(res.data.rcode==200){
          Message.success('操作成功')
          this.flow = false
          this.getList()
          this.ruleForm={
            token:window.sessionStorage.getItem("Token"),
            title:'',
            content:'',
            notice_sceincid:'',
            state:'1',
            sendtime:'',
            id:''
          }
          this.option = []
        }else{
          Message.success(res.data.msg)
        }
      })
    },
    checkedChange(item,e){
      this.$forceUpdate()
    },
    shai(){
      this.secenL()
    },
    secenL(notice_sceincid){
      scenicPost(this.data1).then(res=>{
        if(res.data.rcode==200){
          this.arr = res.data.result.data
          this.arr.map(item=>{
            item.checked = false
          })
          if(notice_sceincid){
            res.data.result.data.map(item=>{
              notice_sceincid.split(',').map(itm=>{
                if(item.ScenicID==itm){
                  this.option.push(item)
                }
              })
            })
          }
          
        }
      })
    },
    formBtns(){
      this.arr.map(item=>{
          if(item.checked==true){
            this.option.push(item)
          }
      })
      this.scenicflow = false
    },
    openscenic(){
      this.secenL()
      this.scenicflow = true
    },
    getList(){
      getNoticeList(this.data).then(res=>{
        if(res.data.rcode==200){
          this.tableData = res.data.result.data
          this.total = res.data.result.total
        }
      })
    },
    scenicClose(){
      this.scenicflow = false
    },
    Close(){
      this.flow = false
      this.option = []
      this.ruleForm={
        token:window.sessionStorage.getItem("Token"),
        title:'',
        content:'',
        notice_sceincid:'',
        state:'1',
        sendtime:'',
        id:''
      }
    },
    btnsTz(){
      this.option = []
      this.flow = true
    },
     // 表头设置
     tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
}
</script>
<style lang="less" scoped>
.conentBox{
  margin-top: 2rem;
  padding: 2rem;
  .btns{
    display: flex;
    justify-content: flex-end;
    margin-bottom: 2rem;
    div{
      cursor: pointer;
      width: 13.2rem;
      height: 3.8rem;
      border: 2px solid #246DEB;
      font-size: 1.4rem;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #246DEB;
      border-radius: 0.4rem;
      font-weight: 500;
      img{
        width: 1.4rem;
        height: 1.4rem;
        margin-right: 1rem;
      }
    }
  }
}
/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  position: relative;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}
.detele{
  color: #FF4D4F;
  font-size: 1.4rem;
  cursor: pointer;
}
.two_btns{
  color: #246DEB;
  font-size: 1.4rem;
  margin-left: 2rem;
  cursor: pointer;
}
::v-deep .el-dialog__headerbtn {
  top: 15px;
  .el-icon-close{
    font-size: 3rem;
  }
}
::v-deep .el-textarea__inner{
    resize: none;
}
.form_tz{
  ::v-deep .el-select{
    width: 100%;
  }
}
.form_btn{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 6rem;
  margin-bottom: 2rem;
  >div{
    width: 10rem;
    height: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.4rem;
    cursor: pointer;
    border-radius: 0.4rem;
    &:nth-child(1){
      border: 1px solid #246DEB;
      color: #246DEB;
    }
    &:nth-child(2){
      background: #246DEB;
      color: #FFFFFF;
      margin-left: 2rem;
    }
  }
}
.scenic_box{
  .top{
    display: flex;
    align-items: center;
    ::v-deep .el-select{
      width: 20rem;
    }
    ::v-deep .el-input:nth-child(2){
      width: 30rem;
      margin-left: 2rem;
    }
    .btns_top{
      width: 10rem;
      height: 4rem;
      background: #246DEB;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      border-radius: 0.4rem;
      font-size: 1.4rem;
      margin-left: 2rem;
      cursor: pointer;
    }
  }
  .bottom{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    height: 40rem;
    margin-top: 4rem;
    overflow: hidden;
    overflow-y: auto;
    >div{
      width: 50%;
      margin-bottom: 2rem;
    }
  }
}
.el_times{
  margin-left: 8rem;
  ::v-deep .el-date-editor{
    width: 100% !important;
  }
}
.tow_btns{
  color: #246DEB;
  margin-left: 2rem;
  cursor: pointer;
}
.fabu{
  width: 100%;
  height: 4rem;
  border: 1px solid #E5E5EA;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  box-sizing: border-box;
  padding: 0 1rem;
  border-radius: 0.4rem;
  cursor: pointer;
  span{
    color: #666666;
    font-size: 1.4rem;
  }
  img{
    width: 1.6rem;
    height: 1.2rem;
  }
}
.scenic{
  display: flex;
  flex-wrap: wrap;
  margin-left: 8rem;
  >div{
    padding: 0.6rem 1rem;
    background: #246DEB;
    color: #fff;
    font-size: 1.4rem;
    margin-bottom: 1rem;
    margin-right:2rem ;
    img{
      width: 1.4rem;
      height: 1.4rem;
      margin-left: 2rem;
      cursor: pointer;
    }
  }
}
</style>